import APIRequest from '../api/APIRequest';

class FeesService {
  // Create a single fee record
  async createFee(feeData, token) {
    const api = new APIRequest();
    return await api.request('/fees/createFee', 'POST', feeData, token);
  }

  // Create fees for all students in a class
  async createBulkFees(bulkData, token) {
    const api = new APIRequest();
    return await api.request('/fees/createBulkFees', 'POST', bulkData, token);
  }

  // Get fees by class ID
  async getFeesByClass(classId, academicYear = null, token) {
    const api = new APIRequest();
    let url = `/fees/getFeesByClass?classId=${classId}`;
    if (academicYear) {
      url += `&academicYear=${academicYear}`;
    }
    return await api.request(url, 'GET', {}, token);
  }

  // Get fees by student ID
  async getFeesByStudent(studentId, token) {
    const api = new APIRequest();
    return await api.request(`/fees/getFeesByStudent?studentId=${studentId}`, 'GET', {}, token);
  }

  // Update fee status
  async updateFeeStatus(feeId, updateData, token) {
    const api = new APIRequest();
    return await api.request(`/fees/updateFeeStatus/${feeId}`, 'PUT', updateData, token);
  }

  // Get fee summary for a student
  async getFeeSummary(studentId, academicYear = null, token) {
    const api = new APIRequest();
    let url = `/fees/getFeeSummary?studentId=${studentId}`;
    if (academicYear) {
      url += `&academicYear=${academicYear}`;
    }
    return await api.request(url, 'GET', {}, token);
  }

  // Get overdue fees
  async getOverdueFees(classId = null, token) {
    const api = new APIRequest();
    let url = '/fees/getOverdueFees';
    if (classId) {
      url += `?classId=${classId}`;
    }
    return await api.request(url, 'GET', {}, token);
  }

  // Get fees statistics
  async getFeesStatistics(classId = null, academicYear = null, token) {
    const api = new APIRequest();
    let url = '/fees/getFeesStatistics';
    const params = [];
    if (classId) params.push(`classId=${classId}`);
    if (academicYear) params.push(`academicYear=${academicYear}`);
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }
    return await api.request(url, 'GET', {}, token);
  }

  // Delete fee record
  async deleteFee(feeId, token) {
    const api = new APIRequest();
    return await api.request(`/fees/deleteFee/${feeId}`, 'DELETE', {}, token);
  }

  // Get students with fees summary
  async getStudentsWithFeesSummary(classId = null, token) {
    const api = new APIRequest();
    let url = '/admin/getStudentsWithFeesSummary';
    if (classId) {
      url += `?classId=${classId}`;
    }
    return await api.request(url, 'GET', {}, token);
  }

  // Get students with detailed fee information
  async getStudentsWithFeeDetails(classId = null, academicYear = null, token) {
    const api = new APIRequest();
    let url = '/fees/getStudentsWithFeeDetails';
    const params = [];
    if (classId) params.push(`classId=${classId}`);
    if (academicYear) params.push(`academicYear=${academicYear}`);
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }
    return await api.request(url, 'GET', {}, token);
  }
}

export const feesService = new FeesService();
